var render = function render(_c,_vm){return _c('div',{staticClass:"card-many-to-many__list-wrapper"},[_c('div',{staticClass:"card-many-to-many__list"},_vm._l((_vm.props.value),function(item){return _c('div',{key:item.id,staticClass:"card-many-to-many__item card-link-row",class:{
        'card-link-row--unnamed': item.value === null || item.value === '',
      }},[_c('span',{staticClass:"card-many-to-many__name"},[_vm._v("\n        "+_vm._s(item.value || 'unnamed row ' + item.id)+"\n      ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }